import { DocumentType } from "../types/Types";
import { isPlanDoc, isRabotenNalog } from "../documents/docTypeChecks";
import { ModuleCode, PLANNING_MODULES } from "./modules";

const INVENTORY_SUBCATEGORIES = ["inventory-count", "inventory-surplus", "inventory-shortage"];

/** Modules that open a document type's screen. Mirrors server/middleware/documentModuleAccess.js
 *  (moduleForType / acceptedModulesForType) + inventoryCount.js, invoice.js, rnWorkOrder*.js.
 *  Any ONE of the returned modules is enough (server: acceptedModulesForType). Keep in sync with the server. */
export function modulesForDocumentType(
  doc: Pick<DocumentType, "category" | "subCategory" | "menuGroup" | "pattern">
): ModuleCode[] {
  if (isRabotenNalog(doc)) return ["WORK_ORDERS"];
  if (doc.subCategory && INVENTORY_SUBCATEGORIES.includes(doc.subCategory)) return ["INVENTORY"];
  if (isPlanDoc(doc)) return PLANNING_MODULES;
  if (doc.menuGroup === "sales" || (doc.category === "non-material" && doc.subCategory === "sales")) {
    return ["NON_MATERIAL_DOCUMENTS", "MATERIAL_DOCUMENTS"];
  }
  if (doc.subCategory === "invoice") return ["NON_MATERIAL_DOCUMENTS"];
  return ["MATERIAL_DOCUMENTS"];
}
